import {
  ApiResponse,
  ApplicationRequest,
  ApplicationResponse,
} from '../types/api';
import { lifeApi } from './base';

const updateApplication = lifeApi.injectEndpoints({
  endpoints: (builder) => ({
    updateApplication: builder.mutation<
      ApiResponse<ApplicationResponse>,
      ApplicationRequest
    >({
      query: (body) => ({
        url: '/',
        method: 'PUT',
        body,
        params: {
          relativeUrl: 'applications',
        },
      }),
    }),
  }),
});

export const { useUpdateApplicationMutation } = updateApplication;
